<template>
  <div>
    <admin-clients-table
      v-if="showTable"
      :clients="clients"
      @setEditedClient="setEditedClient"
    />
    <admin-edit-client
      :selectedAdvertiser="selectedClient"
      :cancel="cancel"
      @returnToClientsTable="returnToClientsTable"
      v-else
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AdminEditClient from './admin-edit-client/Index'
  import AdminClientsTable from './AdminClientsTable'
  export default {
    name: 'AdminComponent',
    components: {
      AdminEditClient,
      AdminClientsTable
    },
    data () {
      return {
        selectedClientId: null,
        cancel: false
      }
    },
    computed: {
      ...mapGetters({
        user: 'getCurrentUser',
        advertisers: 'getAdvertisers'
      }),
      clients () {
        if (!this.user || !this.advertisers.length) return []
        const ids = this.user.firebaseAccount.advertisers.map(a => a.id)
        return this.advertisers.filter(advertiser => ids.find(id => id === advertiser.id)).map(a => {
          return {
            id: a.id,
            name: a.data.name,
            type: a.data.type,
            status: 'Active',
            location: a.data.political.state
          }
        })
      },
      selectedClient () {
        return this.advertisers.find(a => a.id === this.selectedClientId)
      },
      showTable () {
        return this.clients.length > 1 && !this.selectedClient
      }
    },
    methods: {
      setEditedClient (id) {
        this.selectedClientId = id
      },
      returnToClientsTable () {
        this.selectedClientId = null
      }
    },
    watch: {
      user: {
        handler (val) {
          if (val && val.firebaseAccount.advertisers.length === 1) {
            this.selectedClientId = val.firebaseAccount.selectedAdvertiser
          } else if (val.firebaseAccount.advertisers.length > 1) {
            this.selectedClientId = val.firebaseAccount.selectedAdvertiser
            this.cancel = true
          }
        },
        immediate: true,
        deep: true
      }
    }
  }
</script>
